const filterIcon = `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.10571 7L20.8943 7.00001" stroke="#232429" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.10571 12L18.8943 12" stroke="#232429" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.10571 17L16.8943 17" stroke="#232429" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    `;

export default filterIcon;
